import React from "react";
import ReactDOM from "react-dom/client";
import "./global/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { theme } from "./global/theme";
import { PumpRecommendationProvider } from "./context/PumpRecommendationContext";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const logRocketKey = process.env.REACT_APP_LOGROCKET;
if (logRocketKey && logRocketKey.trim()) {
  LogRocket.init(logRocketKey);
  setupLogRocketReact(LogRocket);
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
      >
        <PumpRecommendationProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </PumpRecommendationProvider>
      </GoogleReCaptchaProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
